import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';
import { Fonts } from '../../../utils/resources/fonts';
import { Colors } from '../../../utils/resources/colors';

export interface GridTabCSSStyle extends UIComponentCSSStyle
{
    getHeaderTitleCSSStyle(): object;
    getHeaderTitleDivCSSStyle(): object;
    getTabTitleDivCSSStyle(): object;
    getTabHeaderCSSStyle(): object;
    getTabLinkCSSStyle(isSelected: boolean): object;
    getTabContentCSSStyle(): object;
    getTitleDivCSSStyle(): object;
    getPipeCSSStyle(): object;
}

export class GridTabCSSStyleImpl extends UIComponentCSSStyleImpl implements GridTabCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            // height: "485px",
            paddingBottom: "0px",
            width: "100%",
            // display: "flex",
            // justifyContents: "center",
            // flexDirection: "row",
            // flexFlow: "row wrap"
        };
    }
    getTabHeaderCSSStyle(): object 
    {
        return {
            // height: "40px",
            width: "auto",
            boxSizing: "border-box",
            backgroundColor: "#EAEDF0",
            borderRadius: "10px",
            display: "flex",
            border: "1px solid #EAEDF0",
            position: "relative",
            flexDirection: "row",
            flexFlow: "row wrap",
        };
    }

    getHeaderTitleCSSStyle(): object 
    {
        return {
            display: "inline-block",
            textAlign: "left",
            // height: "30px",
            paddingTop: "5px",
            fontWeight: 800,
            letterSpacing: 0,
            float: "left",
            fontSize: this.getResources().getFont(Fonts.h11),
            color: this.getResources().getColor(Colors.color_4),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "32px",
            cursor: "pointer"
        };
    }

    getTabTitleDivCSSStyle(): object 
    {
        return {

        };
    }

    getHeaderTitleDivCSSStyle(): object 
    {
        return {
            flex: 2
        };
    }

    getTabLinkCSSStyle(isSelected: boolean): object {
        return {
            display: "inline-block",
            textAlign: "center",
            height: "30px",
            paddingTop: "5px",
            fontWeight: 600,
            letterSpacing: 0,
            textShadow: "0 1px 1px 0 rgba(0,0,0,0.18)",
            fontSize: this.getResources().getFont(Fonts.h6),
            color: isSelected ? this.getResources().getColor(Colors.color_2) : this.getResources().getColor(Colors.color_4),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "32px",
            cursor: "pointer"
        };
    }

    getTitleDivCSSStyle(): object 
    {
        return {
            display: "inline",
            cursor: "pointer",
            textAlign: "right"
        };
    }

    getPipeCSSStyle(): object {
        return {
            display: "inline",
            paddingLeft: "14px",
            paddingRight: "14px",
            paddingTop: "10px",
            color: this.getResources().getColor(Colors.color_15)
        };
    }

    getTabContentCSSStyle(): object 
    {
        return {
            // backgroundColor: this.getResources().getColor(Colors.color_5),
            width:"100%",
            height: "100%"
        };
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/gridtabs/gridtabcss.tsx